import { createContext, useContext } from 'react';
export const NotificationPreferencesContext = /*#__PURE__*/createContext(null);
NotificationPreferencesContext.displayName = 'Notification preferences context';
export const useNotificationPreferencesContext = () => {
  const contextMaybe = useContext(NotificationPreferencesContext);
  if (!contextMaybe) {
    throw new Error('useNotificationPreferencesContext called outside of a provider');
  }
  return contextMaybe;
};